@if (gridOptions) {
  <dv-grid [actions]="actions()" (filtersCleared)="onGridFiltersCleared()">
    <dv-panel
      class="trip-filter-panel"
      [showExpandButton]="true"
      [showPinButton]="false"
      [isPinned]="true"
      [isClosedPanelVisible]="true"
      [closedPanelTitle]="' '">
      <div class="trip-filter-panel__form">
        <div
          class="trip-filter-panel__form-wrapper trip-filter-panel__form-wrapper--first-group">
          <span class="trip-filter-panel__form-wrapper--title">{{
            'Trip.Filters.DriverPeriodDepartment' | translate
          }}</span>
          <dv-dynamic-form
            [elements]="departmentDriverAndPeriodElements | translateElements"
            [formGroup]="formGroup">
          </dv-dynamic-form>
        </div>
        <div
          class="trip-filter-panel__form-wrapper trip-filter-panel__form-wrapper--second-group">
          <span class="dv-filter-panel__form-wrapper--title centered-text">{{
            'Trip.Filters.WeekDays' | translate
          }}</span>
          <div class="centered-elements">
            <dv-dynamic-form
              [elements]="monToWedElements | translateElements"
              [formGroup]="formGroup">
            </dv-dynamic-form>
            <dv-dynamic-form
              [elements]="thuToSatElements | translateElements"
              [formGroup]="formGroup">
            </dv-dynamic-form>
            <dv-dynamic-form
              [elements]="sundayElement | translateElements"
              [formGroup]="formGroup">
            </dv-dynamic-form>
          </div>
        </div>
        <div
          class="trip-filter-panel__form-wrapper trip-filter-panel__form-wrapper--third-group">
          <span class="trip-filter-panel__form-wrapper--title centered-text">{{
            'Trip.Filters.Interval' | translate
          }}</span>
          <div
            class="trip-filter-panel__form-wrapper trip-filter-panel__form-wrapper--third-layout">
            <dv-dynamic-form
              class="full-width"
              [elements]="intervalElements | translateElements"
              [formGroup]="formGroup">
            </dv-dynamic-form>
          </div>
        </div>
      </div>
    </dv-panel>
    <ag-grid-angular
      vtGridWithSidesheet
      vtGridRowEditing
      [entity]="entity.Trip"
      [entityId]="$safeNavigationMigration(selectedNode?.id)"
      class="ag-theme-devinco"
      [isSortSaveEnabled]="false"
      [customColumnState]="customColumnState"
      [pinnedBottomRowData]="gridOptions.context.pinnedBottomRowData"
      [gridOptions]="gridOptions"
      (selectionChanged)="onSelectionChanged($event)"
      (gridReady)="onGridReady($event)"
      (rowEditingStarted)="onRowEditingStarted($event)"
      (filterChanged)="onFilterChanged($event)">
    </ag-grid-angular>
  </dv-grid>
}

@if (excelLoadingTrigger$ | async; as excelDownloadLoading) {
  @if (reportInProgressText$ | async; as text) {
    <dv-progress-spinner
      [text]="text"
      [isFullScreenSpinner]="true"
      [displayProgressSpinner]="excelDownloadLoading"></dv-progress-spinner>
  }
}
